import * as service from "../common/service";
import { getCurrentApiBaseUrl } from "../common/constants";

const deviceDataApi = `${getCurrentApiBaseUrl()}/data/devicedata-advanced`;
const usersApi = `${deviceDataApi}/owner`;
const devicePropSetIdApi = `${getCurrentApiBaseUrl()}/user/deviceproperty`
const updateGuestMappingApi = `${getCurrentApiBaseUrl()}/data/devicedata`;
const guestInvite = `${getCurrentApiBaseUrl()}/observer/invite`;

const guestMapService = {
    getPatientSensorList: (payload) => {
        let url = usersApi + "?sortBy=maxValueProvidedOn&sortOrder=DESC";
        return service.postVersionJson(url, payload, 'text', 3);
    },
    getGuestsList: (payload) => {
        return service.postVersionJson(deviceDataApi, payload, 'text', 3);
    },
    getDevicePropSetId: (payload) => {
        return service.get(devicePropSetIdApi + '?deviceDataModelId=' + payload);
    },
    updateGuest: (payload) => {
        return service.postVersionJson(updateGuestMappingApi, payload, 'text', 3);
    },
    onInviteGuest: (payload) => {
        return service.postVersionJson(guestInvite, payload, 'text', 3);
    }
};

export default guestMapService;
